<script setup lang="ts">
import { tooltipText } from '@/constant/tooltip'

import type { UtmParamsFormModel } from '@/types/shorterUrlForm'

interface UtmFieldConfig {
  key: keyof UtmParamsFormModel
  placeholder: string
  tooltipContent: string
}

interface Props {
  isTelUrlCreating?: boolean
}

const { isTelUrlCreating = false } = defineProps<Props>()

const modelValue = defineModel<UtmParamsFormModel>({
  default: {
    campaignSource: '',
    campaignMedium: '',
    campaignName: '',
    campaignTerm: '',
    campaignContent: ''
  }
})

const tooltipPlacement = 'right'

const utmFields: UtmFieldConfig[] = [
  {
    key: 'campaignSource',
    placeholder: 'Campaign Source',
    tooltipContent: tooltipText.campaignSource
  },
  {
    key: 'campaignMedium',
    placeholder: 'Campaign Medium',
    tooltipContent: tooltipText.campaignMedium
  },
  {
    key: 'campaignName',
    placeholder: 'Campaign Name',
    tooltipContent: tooltipText.campaignName
  },
  {
    key: 'campaignTerm',
    placeholder: 'Campaign Term',
    tooltipContent: tooltipText.campaignTerm
  },
  {
    key: 'campaignContent',
    placeholder: 'Campaign Content',
    tooltipContent: tooltipText.campaignContent
  }
]
</script>
<template>
  <div class="mb-4 mt-2">
    <el-tooltip v-for="(field, index) in utmFields" :key="index" :placement="tooltipPlacement">
      <el-input
        v-model="modelValue[field.key]"
        class="mb-4"
        autocomplete="off"
        :placeholder="field.placeholder"
        :disabled="isTelUrlCreating"
      ></el-input>
      <template #content>
        <div v-html="field.tooltipContent"></div>
      </template>
    </el-tooltip>
  </div>
</template>

<style scoped></style>
